<template>
  <tr>
    <td>
      <p>{{ o.id }}</p>
      <p>{{ printDate(o.report_date) }}</p>
    </td>
    <td>
      <p v-for="d in o.details">{{ d.drug.title }} x <strong>{{ d.qty }}</strong> x
        <strong>{{ d.price }}</strong></p>
    </td>
    <td>
      <p>Заявка: <strong>{{ o.price }}</strong></p>
      <p>Доставка: <strong>{{ o.delivery_price }}</strong></p>
      <p>Скидка: <strong>{{ o.discount_type === 1 ? '%' : '' }}{{ o.discount }}</strong></p>
    </td>
    <td>
      <p v-for="d in ordersChanges[o.id].details">{{ d.drug.title }} x <strong>{{ d.qty }}</strong> x
        <strong>{{ d.price }}</strong></p>
    </td>
    <td>
      <p>Заявка: <strong>{{ ordersChanges[o.id].orderFinance.price }}</strong></p>
      <p>Доставка: <strong>{{ ordersChanges[o.id].orderFinance.delivery_price }}</strong></p>
      <p>Скидка: <strong>{{ ordersChanges[o.id].orderFinance.discount }}</strong></p>
    </td>
    <td>
      <button @click="updateOrders(o.id)" type="button" class="btn btn-outline-info">Выбрать</button>
    </td>
  </tr>
</template>

<script>

export default {
  props: ['o', 'ordersChanges', 'updateOrders']
}

</script>
